import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightTheme = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 13,
		cy: 13,
		r: 5.25,
		stroke: "currentColor",
		strokeWidth: 1.8
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13 1.75V4.25M13 21.75V24.25M4.94 4.94L6.71 6.71M19.29 19.29L21.06 21.06M1.75 13H4.25M21.75 13H24.25M4.94 21.06L6.71 19.29M19.29 6.71L21.06 4.94",
		stroke: "currentColor",
		strokeWidth: 1.8,
		strokeLinecap: "round"
	})]
});
export default SvgLightTheme;
